/* MARELD: complementary groups, native theme cards, live availability verification. */
(() => {
  if (customElements.get('mareld-complete-look')) return;
  const text = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const kind = value => {
    const t = text(value);
    const rules = [
      ['swim', /bikini|badeanzug|bademode|tankini/],
      ['headwear', /mutze|muetze|beanie|balaklava|balaclava|(^|\W)(hut|hute|cap|caps|kappe)(\W|$)/],
      ['gloves', /handschuh|gloves?/],
      ['hair', /haarschmuck|haarspange|haarreif|haargummi|scrunchie/],
      ['hosiery', /strumpf|socken|socks?/],
      ['night', /nacht|pyjama|bademantel|morgenmantel|schlafanzug/],
      ['slippers', /hausschuh|pantoffel|slippers?/],
      ['bra', /(^|\W)bh(s)?(\W|$)|bustier|bralette/],
      ['brief', /slip|string|panty|panties|unterhose/],
      ['intimate', /dessous|unterwasche|shapewear|korsett|unterrock|lingerie/],
      ['scarf', /schal|tuch|poncho/],
      ['jewelry', /schmuck|kette|ohrring|ohrstecker|armband|armreif|manschette|brosche|charms|ear.?cuff|(^|\W)(ring|ringe|uhr|uhren)(\W|$)/],
      ['bag', /tasche|rucksack|clutch|shopper/],
      ['shoes', /schuh|stiefel|pumps|sandale|sneaker|loafer|ballerina|mokassin/],
      ['outer', /jacke|mantel|parka|blazer|sakko|cardigan/],
      ['bottom', /hose|rock|leggings|shorts|culotte/],
      ['dress', /kleid|overall|jumpsuit/],
      ['hoodie', /hoodie|kapuzenpullover|kapuzensweat/],
      ['top', /bluse|shirt|pullover|sweat|body|bodies|(^|\W)top(\W|$)|tunika|weste/],
      ['belt', /gurtel|guertel|belt/]
    ];
    return rules.find(([, regex]) => regex.test(t))?.[0] || '';
  };
  const allowed = {
    dress: ['jewelry', 'bag', 'shoes', 'belt', 'hosiery'],
    top: ['bottom', 'jewelry', 'bag', 'belt'],
    hoodie: ['bottom', 'shoes', 'bag', 'headwear'],
    bottom: ['top', 'bag', 'shoes', 'belt'],
    outer: ['scarf', 'bag', 'shoes', 'headwear', 'gloves'],
    headwear: ['scarf', 'gloves', 'bag'], gloves: ['scarf', 'headwear'],
    shoes: ['bag', 'jewelry', 'hosiery'], bag: ['jewelry', 'scarf', 'hair'],
    jewelry: ['bag', 'hair'], hair: ['jewelry', 'bag'], scarf: ['headwear', 'gloves', 'bag'],
    belt: ['top', 'bottom'], hosiery: ['shoes'],
    bra: ['brief'], brief: ['bra'], intimate: ['hosiery'], night: ['slippers'],
    slippers: [], swim: ['headwear', 'bag', 'shoes']
  };
  const candidateGroup = value => { const result = kind(value); return result === 'hoodie' ? 'top' : result; };
  const family = value => {
    const t = text(value);
    return [ ['black', /schwarz|black/], ['white', /weiss|white|creme|ecru/],
      ['beige', /beige|sand|taupe|nude/], ['brown', /braun|brown|cognac|camel/],
      ['blue', /blau|blue|navy/], ['green', /grun|green|olive|khaki/],
      ['red', /rot|red|bordeaux/], ['pink', /rosa|pink|rose/],
      ['grey', /grau|grey|gray|anthrazit/], ['metal', /gold|silber|silver/],
      ['purple', /lila|violett/], ['yellow', /gelb|yellow/], ['orange', /orange|koralle/] ]
      .find(([, regex]) => regex.test(t))?.[0] || '';
  };
  const hash = value => {
    let result = 2166136261;
    for (const char of String(value)) result = Math.imul(result ^ char.charCodeAt(0), 16777619);
    return result >>> 0;
  };
  const score = (source, candidate) => {
    const a = family(source.color), b = family(candidate.color);
    const sourceKind = kind(source.type) || kind(source.title);
    const title = text(source.title), left = text(source.features), right = text(candidate.features);
    let result = a && b && a === b ? 24 : ['black', 'white', 'beige', 'grey', 'metal'].includes(b) ? 5 : 0;
    const formal = /abend|cocktail|festlich|hochzeit|pailletten|satin/.test(title) || /abendveranstaltung|festliche anlasse/.test(left);
    const casual = /sport|hoodie|kapuzen|sweat|jeans|denim|parka|bomber|winter|stepp|strick/.test(title);
    const summer = /sommer|leinen|strand|kurzarm|armlos/.test(title);
    const winter = /winter|woll|stepp|parka|mantel/.test(title);
    if (sourceKind === 'outer') {
      if (candidate.group === 'scarf') result += 16;
      if (candidate.group === 'bag' && /shopper|tragetasche|rucksack|umhangetasche|crossbody|alltag|everyday/.test(right)) result += 18;
      if (candidate.group === 'shoes' && /stiefel|boots|sneaker/.test(right)) result += 10;
      if (!formal && /clutch|pailletten|funkel|strass/.test(right)) result -= 24;
    }
    if (sourceKind === 'headwear' && candidate.group === 'scarf') result += 16;
    if (sourceKind === 'headwear' && candidate.group === 'gloves') result += 12;
    if (sourceKind === 'hoodie' && /sneaker|rucksack|crossbody|jeans|jogger|beanie/.test(right)) result += 18;
    if (sourceKind === 'hoodie' && /abend|clutch|strass|funkel|pumps/.test(right)) result -= 30;
    if (sourceKind === 'dress' && candidate.group === 'jewelry') result += 10;
    if (formal) {
      if (/clutch|abendtasche|strass|funkel|perlen|pumps|sandalette/.test(right)) result += 24;
      if (/rucksack|shopper|sporttasche|sneaker|gummistiefel/.test(right)) result -= 24;
    }
    if (casual) {
      if (/alltag|everyday|minimalist|crossbody|sneaker|shopper/.test(right)) result += 12;
      if (/abendtasche|pailletten|funkel|strass/.test(right)) result -= 14;
    }
    if (summer && /sandale|sandalette|stroh|bast/.test(right)) result += 14;
    if (summer && /winter|gefuttert|woll|stiefel/.test(right)) result -= 20;
    if (winter && /woll|warm|stiefel|strick/.test(right)) result += 12;
    if (winter && /strand|stroh|bast|sandale/.test(right)) result -= 18;
    if (/v.ausschnitt|carmen|off.shoulder/.test(title) && /halskette/.test(right)) result += 10;
    for (const pattern of [/boho|ethno/, /sportlich|sport/, /minimalist/, /leopard|animal/, /perlen/]) {
      if (pattern.test(left) && pattern.test(right)) result += 8;
    }
    // Less than one point: only breaks equally relevant ties, stable on reload.
    return result + hash(`${source.id}:${source.color}:${candidate.id}`) / 4294967296;
  };
  customElements.define('mareld-complete-look', class extends HTMLElement {
    connectedCallback() {
      Promise.resolve().then(() => window.MareldRecommendationTracking?.refresh());
      this.token = (this.token || 0) + 1;
      this.hidden = true;
      this.onVariant = event => {
        if (String(event.data?.sectionId || '') !== this.mainInfo()?.dataset.section) return;
        this.variant = event.data.variant;
        const source = this.source();
        if (this.started && `${source.id}:${source.color}` !== this.lastSourceKey) this.refresh();
      };
      if (window.FoxTheme?.pubsub) this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, this.onVariant);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.started = true; this.refresh(); }
        }, {rootMargin: '500px'});
        // The Shopify section wrapper remains measurable even while our empty content is hidden.
        this.observer.observe(this.closest('.shopify-section') || this.parentElement);
      } else { this.started = true; this.refresh(); }
    }
    disconnectedCallback() { this.token++; this.controller?.abort(); this.observer?.disconnect(); this.unsubscribe?.(); }
    mainInfo() { return document.querySelector('product-info[id^="MainProduct"]'); }
    source() {
      const data = JSON.parse(this.querySelector('[data-look-source]').textContent);
      const info = this.mainInfo();
      let variant = this.variant;
      if (variant === undefined) {
        try { variant = JSON.parse(info?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch {}
      }
      if (variant && data.colorIndex >= 0) data.color = variant.options?.[data.colorIndex] || data.color;
      else if (variant === null && this.currentColor !== undefined) data.color = this.currentColor;
      return data;
    }
    async refresh() {
      const token = ++this.token;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const source = this.source();
      this.currentColor = source.color;
      this.lastSourceKey = `${source.id}:${source.color}`;
      const sourceKind = kind(source.type) || kind(source.title);
      const groups = allowed[sourceKind] || [];
      const candidates = [];
      let records = [];
      try { records = JSON.parse(this.querySelector('[data-look-candidates]')?.textContent || '[]'); } catch {}
      // Compatibility with a previously rendered v1 section during deployment.
      if (!records.length) for (const template of this.querySelectorAll('template[data-look-candidate]')) {
        try { records.push(JSON.parse(template.dataset.lookCandidate)); } catch {}
      }
      for (const data of records) {
        if (!groups.includes(data.group) || String(data.id) === String(source.id)) continue;
        if ((candidateGroup(data.type) || candidateGroup(data.title)) !== data.group) continue;
        // Beachwear only receives explicit beach/summer accessories, not generic dress suggestions.
        if (sourceKind === 'swim' && !/strand|beach|stroh|bast|sommer|sandale|flip.?flop/.test(text(data.features))) continue;
        candidates.push({...data, score: score(source, data)});
      }
      const ranked = candidates.sort((a, b) => b.score - a.score);
      const checked = [], attempted = new Set(), perGroup = new Map();
      const limit = Number(this.dataset.limit || 4);
      const loadCard = async candidate => {
        if (!/^[a-z0-9-]+$/.test(candidate.handle)) return null;
        try {
          const url = `${this.dataset.productRoot}${candidate.handle}?section_id=mareld-look-card`;
          const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
          if (!response.ok) return null;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = parsed.querySelector('[data-look-card]');
          if (!card || card.dataset.available !== 'true' || String(card.dataset.productId) !== String(candidate.id)) return null;
          return {...candidate, card};
        } catch { return null; }
      };
      while (checked.length < limit && attempted.size < 12) {
        const planned = [], counts = new Map();
        for (const candidate of checked) counts.set(candidate.group, (counts.get(candidate.group) || 0) + 1);
        const add = candidate => {
          if (!candidate || attempted.has(String(candidate.id)) || planned.some(item => String(item.id) === String(candidate.id))) return;
          if (planned.length >= limit - checked.length || planned.length >= 12 - attempted.size || (counts.get(candidate.group) || 0) >= 2) return;
          planned.push(candidate); counts.set(candidate.group, (counts.get(candidate.group) || 0) + 1);
        };
        // One representative per available group, then the highest-ranked extras.
        for (const group of groups) {
          if (!counts.get(group)) add(ranked.find(item => item.group === group && !attempted.has(String(item.id))));
        }
        for (const candidate of ranked) add(candidate);
        if (!planned.length) break;
        for (const candidate of planned) attempted.add(String(candidate.id));
        for (let offset = 0; offset < planned.length; offset += 3) {
          if (token !== this.token || !this.isConnected) return;
          const batch = await Promise.all(planned.slice(offset, offset + 3).map(loadCard));
          if (token !== this.token || !this.isConnected) return;
          checked.push(...batch.filter(Boolean));
        }
      }
      const selected = [];
      const rankedLive = checked.sort((a,b) => b.score - a.score);
      // At least one representative of every suitable configured group before extras.
      for (const group of groups) {
        const candidate = rankedLive.find(item => item.group === group);
        if (candidate && selected.length < limit) {
          selected.push(candidate); perGroup.set(group, 1);
        }
      }
      for (const candidate of rankedLive) {
        if (selected.length >= limit) break;
        if (selected.some(item => String(item.id) === String(candidate.id)) || (perGroup.get(candidate.group) || 0) >= 2) continue;
        selected.push(candidate); perGroup.set(candidate.group, (perGroup.get(candidate.group) || 0) + 1);
      }
      selected.sort((a,b) => b.score - a.score);
      if (token !== this.token || !this.isConnected) return;
      const grid = this.querySelector('[data-look-grid]');
      grid.replaceChildren(...selected.map(candidate => document.importNode(candidate.card, true)));
      this.hidden = selected.length === 0;
    }
  });
})();

/* MARELD recommendation events v1. No cookies, storage or direct analytics requests. */
(() => {
  if (window.MareldRecommendationTracking) return;
  const selector = 'mareld-complete-look, mareld-size-alternatives';
  const cardSelector = '[data-look-card], .msa-card';
  const roots = new Map();
  const publish = (name, data) => {
    if (window.Shopify?.designMode || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try { Promise.resolve(window.Shopify.analytics.publish(`mareld:${name}`, data)).catch(() => {}); return true; }
    catch { return false; }
  };
  const dataFor = (root, card, clickedLink) => {
    const link = clickedLink || (card.matches('a[href]') ? card : card.querySelector('a[href*="/products/"]'));
    if (!link) return null;
    let url;
    try { url = new URL(link.href, window.location.origin); } catch { return null; }
    if (url.origin !== window.location.origin) return null;
    const handle = url.pathname.match(/\/products\/([^/]+)/)?.[1];
    if (!handle) return null;
    let sourceId = root.dataset.productId || root.dataset.product || '';
    try { sourceId = JSON.parse(root.querySelector('[data-look-source]')?.textContent || '{}').id || sourceId; } catch {}
    const main = document.querySelector('product-info[id^="MainProduct"]');
    sourceId = sourceId || main?.dataset.productId || '';
    const list = root.localName === 'mareld-complete-look' ? 'complete_look' : 'size_alternatives';
    const cards = [...root.querySelectorAll(cardSelector)];
    return {schema_version: 1, recommendation_list: list, source_product_id: String(sourceId),
      product_id: String(card.dataset.productId || ''), product_handle: handle,
      variant_id: String(card.dataset.variantId || url.searchParams.get('variant') || ''),
      position: cards.indexOf(card) + 1};
  };
  const attach = root => {
    if (roots.has(root)) return;
    const seen = new Set(), timers = new Map(), watched = new Set();
    const stopTimer = card => { clearTimeout(timers.get(card)); timers.delete(card); };
    const visible = card => {
      const rect = card.getBoundingClientRect();
      const intersection = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)) *
        Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      return card.isConnected && rect.width > 0 && rect.height > 0 && intersection / (rect.width * rect.height) >= .5;
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        const card = entry.target;
        stopTimer(card);
        if (!entry.isIntersecting || entry.intersectionRatio < .5 || document.visibilityState === 'hidden') continue;
        timers.set(card, setTimeout(() => {
          timers.delete(card);
          if (document.visibilityState === 'hidden' || !visible(card)) return;
          const data = dataFor(root, card);
          if (!data) return;
          const key = `${data.product_handle}:${data.variant_id}`;
          if (!seen.has(key) && publish('recommendation_view', data)) seen.add(key);
        }, 1000));
      }
    }, {threshold: [.5]}) : null;
    const scan = () => {
      for (const card of watched) if (!card.isConnected) { observer?.unobserve(card); stopTimer(card); watched.delete(card); }
      for (const card of root.querySelectorAll(cardSelector)) if (!watched.has(card)) { watched.add(card); observer?.observe(card); }
    };
    const mutation = new MutationObserver(scan);
    mutation.observe(root, {childList: true, subtree: true});
    const click = event => {
      const link = event.target.closest?.('a[href]');
      if (!link || !root.contains(link)) return;
      try {const url = new URL(link.href, window.location.origin); if (url.origin !== window.location.origin || !/\/products\/[^/]+/.test(url.pathname)) return;} catch {return;}
      const card = link.closest(cardSelector);
      if (!card || !(card === link || card.contains(link))) return;
      const data = dataFor(root, card, link);
      if (data) publish('recommendation_click', data);
    };
    root.addEventListener('click', click);
    roots.set(root, {cleanup() { mutation.disconnect(); observer?.disconnect(); timers.forEach(clearTimeout); root.removeEventListener('click', click); }});
    scan();
  };
  const init = () => {
    for (const [root, state] of roots) if (!root.isConnected) {state.cleanup(); roots.delete(root);}
    document.querySelectorAll(selector).forEach(attach);
  };
  window.MareldRecommendationTracking = {version: 1, refresh: init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();
